module.exports = __webpack_public_path__ + "img/LabylokWhite.4d42aec5.png";